import service from "@/store/services/estimate-vehicle-makes-service";

export const state = () => ({
  list: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((make) => ({
      id: make.id,
      name: `${make.name}`,
    }));
  },
};

const makes = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default makes;
